// @flow
import * as React from 'react';

import { CountryName } from '@gandi/react-places';
import type { FavoriteContact } from '@gandi/redux-resource-contactbook';
import { useTranslator } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';

import { getDisplayedType, getDisplayName } from '../../../../modules/helpers';

export type Props = {
  contact: FavoriteContact,
};

const ContactDetails = ({ contact }: Props) => {
  const translator = useTranslator();

  return (
    <Base padding="small">
      <Base tagName="p" margin="none">
        <Base tagName="span" flex flexAlignItemsCenter weight="semibold">
          {getDisplayName(contact)}
        </Base>
        <Text color="light">{getDisplayedType(translator, contact.type)}</Text>
        <br />
        {contact.email}
        {contact.streetaddr && (
          <>
            <br />
            {contact.streetaddr}
          </>
        )}
        {(contact.zip || contact.city) && (
          <>
            <br />
            {contact.zip} {contact.city}
          </>
        )}
        {contact.country && (
          <>
            <br />
            <CountryName country={contact.country} />
          </>
        )}
        {contact.phone && (
          <>
            <br />
            {contact.phone}
          </>
        )}
      </Base>
    </Base>
  );
};

export default (React.memo<Props>(ContactDetails): React.ComponentType<Props>);
